<template>
  <div class="HubNetworkSettings lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="HubNetworkSettings-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="HubNetworkSettings-main lxn-pos-rel">
      <div class="HubNetworkSettings-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.HubNetworkSettings_title}}
          </template>
          <template v-slot:body>
            <div class="HubNetworkSettings-wrapper-fieldTitle lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.HubNetworkSettings_text1}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="currentNetworkType" :dropDownContex="dropDownData" :disabled="isHubOffline" />
            </div>
            <div class="HubNetworkSettings-wrapper-fieldTitle lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.HubNetworkSettings_text2}}
            </div>
            <div v-if="currentNetworkType == 0" class="lxn-w100 lxn-pos-rel">
              <customInput @focus="input1FieldState='active'" @blur="input1FieldState=''" :inputState="input1FieldState" v-model="ssid" bgColor="#FFFFFF" placeHolder="SSID" inputType="text" />
              <div class="HubNetworkSettings-wrapper-searchIcon lxn-pos-abs lxn-w100">
                <ButtonIcon @click="searchNetwork()" :size="40" bgColor="#1EA5DE" icon="search" iconColor="#FFFFFF" :padding="8" />
              </div>
            </div>
            <div v-else class="lxn-w100 lxn-title lxn-text-en lxn-text-center">
              {{AccessPointName}}
            </div>
            <div class="HubNetworkSettings-wrapper-fieldTitle lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.HubNetworkSettings_text3}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input2FieldState='active'" @blur="input2FieldState=''" :inputState="input2FieldState" v-model="password" bgColor="#FFFFFF" placeHolder="Password" inputType="text" />
            </div>
            <div class="HubNetworkSettings-wrapper-ssidDropDown lxn-overflow-hidden">
              <DropDown ref="ssidsDropDown" v-model="selectedWIFI" :dropDownContex="scannedSSIDs" />
            </div>
           
          </template>
        </TitleBox>
      </div>
      <div class="HubNetworkSettings-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true" :disabled="isHubOffline">
          {{$store.getters.language.texts.HubNetworkSettings_button}}
        </CustomButton>
      </div>
    </div>
    <div class="HubNetworkSettings-main lxn-pos-rel" style="z-index: 0;">
      <div class="HubNetworkSettings-main-wrapper lxn-margin-auto lxn-border-round" style="margin-top:0px">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.HubStaticIp_title}}
          </template>
          <template v-slot:body>
          
            <div class="HubNetworkSettings-wrapper-fieldTitle lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.HubNetworkSettings_text4}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input2FieldState='active'" @blur="input2FieldState=''" :inputState="input2FieldState" v-model="ip" bgColor="#FFFFFF" placeHolder="IP" inputType="text" />
            </div>
            <div class="HubNetworkSettings-wrapper-fieldTitle lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.HubNetworkSettings_text5}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input2FieldState='active'" @blur="input2FieldState=''" :inputState="input2FieldState" v-model="port" bgColor="#FFFFFF" placeHolder="Port" inputType="text" />
            </div>
          </template>
        </TitleBox>
      </div>
      <div class="HubNetworkSettings-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveIp" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true" >
          {{$store.getters.language.texts.HubStaticIp_button}}
        </CustomButton>
      </div>
      <div class="HubNetworkSettings-button lxn-margin-auto lxn-w100">
        <CustomButton @click="disableIp" bgColor="rgb(243, 108, 79)" iconRight="arrowRight" iconRightColor="#F36C4F" iconRightBgColor="#F5C7BD" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true" :disabled="isStaticIpActive">
          {{$store.getters.language.texts.HubStaticIp_button2}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import CustomInput from '@/components/CustomInput.vue'
import ButtonIcon from '@/components/ButtonIcon.vue'
import DropDown from '@/components/DropDown.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'

var messaging = new Messaging(new Logger(false));

export default {
  name: 'HubNetworkSettings',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    ButtonIcon,
    DropDown
  },
  data: function () {
    return {
      hub: this.$store.getters.getHubByUUID(this.$route.params.hubUUID),
      currentNetworkType: 0,
      input1FieldState: '',
      input2FieldState: '',
      ssid: '',
      password: '',
      ip: this.$store.getters.getHubByUUID(this.$route.params.hubUUID).ipAddress,
      port:  this.$store.getters.getHubByUUID(this.$route.params.hubUUID).port,
      selectedWIFI: -1,
      AccessPointName: '',
      staticIp : this.$store.getters.getHubByUUID(this.$route.params.hubUUID).staticIp
    }
  },
  mounted: function () {
    this.currentNetworkType = this.networkType;
    this.ssid = this.hubSSID;
    this.AccessPointName = this.$store.state.defaultWifiPrefix + messaging.utility.uuidToHexString(this.hub.uuid).toUpperCase();
  },
  watch: {
    networkType: function (newVal) {
      if(newVal != undefined){
        this.currentNetworkType = newVal;
      }else{
        this.currentNetworkType = 0;
      }
    },
    selectedWIFI: function (newVal) {
      if(newVal != -1){
        this.ssid = this.scannedSSIDs.data[newVal].name;
      }
    },
    hubSSID: function (newVal) {
      this.ssid = newVal;
    },
  },
  computed: {
    networkType: function () {
      var networkType = this.hub.wifiType;
      if(this.hub.wifiType == "STA"){
        networkType = 0;
      }else{
        networkType = 1;
      }
      return networkType;
    },
    isHubOffline: function () {
      if(this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2){
        return false;
      }else{
        return true;
      }
    },
    isStaticIpActive: function () {
      if(this.hub.staticIp == true){
        return false
      }else{
        return true
      }
    },
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.hub.color];
    },
    dropDownData: function () {
      return {
        name: "HubNetworkSettings-networkType",
        title: this.$store.getters.language.texts.HubNetworkSettings_text1,
        selectedIndex: this.currentNetworkType,
        data: [
          {
            name: "Station",
            icon: 'lamp',
          },
          {
            name: "Access Point",
            icon: 'lamp',
          },
        ]
      }
    },
    scannedSSIDs: function () {
      return {
        name: "HubNetworkSettings-outputInitialState",
        title: this.$store.getters.language.texts.HubNetworkSettings_text2,
        selectedIndex: -1,
        data: [
        ]
      }
    },
    hubSSID: function () {
      if(this.hub.wifiType == "STA"){
        return this.hub.ssid;
      }else{
        return this.AccessPointName
      }
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    searchNetwork: function () {
      this.$store.commit('setAppBusy', true);
      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: this.hub.psk,
        destinationUUID: this.hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });
      this.$store.dispatch('scanWiFiNetworks', {messagingHook: messagingHook,hubUUID: this.hub.uuid})
      .then( response => {
        var networkList = response.body.bodyContent.networkList;
        this.scannedSSIDs.data = [];
        for(var i = 0; i < networkList.length; i++){
          this.scannedSSIDs.data.push({
            name: networkList[i].ssid,
            icon: networkList[i].encryption == 0 ? 'unlocked' : 'locked',
          })
        }
        if(networkList.length > 0){
          this.selectedWIFI = -1;
          this.$refs.ssidsDropDown.openDropDownModal();
        }
        this.$store.commit('setAppBusy', false);
      })
      .catch( response => {
        if(response.rejectCode == 2){
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
        alert(this.$store.getters.language.texts.HubNetworkSettings_alert);
        this.$store.commit('setAppBusy', false);
      });
    },
    saveChanges: function () {
      this.input1FieldState = '';
      this.input2FieldState = '';
      if(this.ssid == ''){
        this.input1FieldState = 'error';
        alert(this.$store.getters.language.texts.HubNetworkSettings_alert2);
      }else if(this.password == '' && this.currentNetworkType == 1){
        this.input2FieldState = 'error';
        alert(this.$store.getters.language.texts.HubNetworkSettings_alert3);
      }else if(this.password.length < 8 && this.currentNetworkType == 1){
        this.input2FieldState = 'error';
        alert(this.$store.getters.language.texts.HubNetworkSettings_alert4);
      }else{
        this.$store.commit('setAppBusy', true);
          var messagingHook = new Messaging(new Logger(false));
          messagingHook.init({
            psk: this.hub.psk,
            destinationUUID: this.hub.uuid,
            sourceUUID: this.$store.state.user.uuid
          });
          this.$store.dispatch('setHubWifi', {
            messagingHook: messagingHook,
            hubUUID: this.hub.uuid,
            bodyContent: {
              wifiMode: this.currentNetworkType,
              wifiPassword: this.password,
              wifiSSID: this.ssid,
            }
          })
          .then( () => {
            this.$store.commit('setHubStatus', {
              hubIndex: this.hub.index,
              connectionStatus: {
                local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              },
            });
            this.$router.push('/NetworkSettingsSuccess');
            this.$store.commit('setAppBusy', false);
          })
          .catch( response => {
            if(response.rejectCode == 2){
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            }
            this.$router.push('/SettingsHubError');
            this.$store.commit('setAppBusy', false);
          });
      }
    },
    saveIp: function () {
      console.log('saveIp => ', this.ip)
      this.$store.commit('setHubStatus', {
        hubIndex: this.hub.index,
        ipAddress: this.ip,
        staticIp: true,
        port: this.port
      });
      alert(this.$store.getters.language.texts.HubStaticIp_alert);
      this.$store.dispatch('startStatusUpdate');
      this.$store.commit("saveState");
    },
    disableIp: function () {
      console.log('disableIp => ', this.ip)
      this.$store.commit('setHubStatus', {
        hubIndex: this.hub.index,
        ipAddress: '',
        staticIp: false,
        port: 80
      });
      alert(this.$store.getters.language.texts.HubStaticIp_alert2);
      this.ip = '';
      this.$store.dispatch('startStatusUpdate');
      this.$store.commit("saveState");
    }
  }
}
</script>

<style>
  .HubNetworkSettings-topCurve-wrapper {
    height: 200px;
  }
  .HubNetworkSettings-main {
    z-index: 2;
  }
  .HubNetworkSettings-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .HubNetworkSettings-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .HubNetworkSettings-wrapper-fieldTitle:first-child {
    height: 25px;
    line-height: 25px;
    padding-top: 0;
  }
  .HubNetworkSettings-wrapper-fieldTitle {
    height: 35px;
    padding-top: 10px;
    line-height: 25px;
    color: #52626C;
  }
  .HubNetworkSettings-wrapper-searchIcon {
    width: 40px;
    height: 40px;
    left: 5px;
    top: 5px;
  }
  .HubNetworkSettings-wrapper-ssidDropDown  {
    height: 0px;
  }
</style>
